module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"tariffInactive":"Тариф закончился","expiredTariffText":"Для получения доступа к функциям Вашего тарифа необходимо внести оплату.","expiredTariffButton":"Оплатить тариф"}}')
  delete Component.options._Ctor
}
